import { isNil, cond, constant, stubTrue } from "lodash";
import Asset3DWithNoAnimation from "../Asset3DWithNoAnimation";
import {
  Asset3DAnimationType,
  BaseAnimationWithAssetProps,
  AnimationType,
  InteractionType3D,
  KeyframeAnimationAssetPlaybackActionType,
} from "../types";
import KeyFrameAnimationWithAsset from "./KeyframeAnimationWithAsset";
import VideoAnimationWithAsset from "./VideoAnimationWithAsset";
import { LoopOnce, LoopPingPong, LoopRepeat } from "three";

export const playbackActionToThreePlaybackAction = {
  [KeyframeAnimationAssetPlaybackActionType.LoopOnce]: LoopOnce,
  [KeyframeAnimationAssetPlaybackActionType.LoopRepeat]: LoopRepeat,
  [KeyframeAnimationAssetPlaybackActionType.LoopPingPong]: LoopPingPong,
};

const hasNecessaryKeyframeParts = (animation: AnimationType) => {
  return (
    !isNil(animation.actionName) &&
    animation.playbackAction !== undefined &&
    animation.__typename === Asset3DAnimationType.KeyframeAnimation
  );
};

const hasNecessaryVideoAnimation = (animation: AnimationType) => {
  return (
    animation.__typename === Asset3DAnimationType.AssetAnimation &&
    !isNil(animation.asset)
  );
};

export const getAssetComponent = (
  a?: AnimationType,
  interactionType?: InteractionType3D,
) => {
  if (a === undefined || interactionType === undefined)
    return Asset3DWithNoAnimation;
  return cond([
    [
      (a: AnimationType) => hasNecessaryVideoAnimation(a),
      constant((props: BaseAnimationWithAssetProps) => (
        <VideoAnimationWithAsset
          videoAsset={a.asset!}
          interactionType={interactionType}
          {...props}
        />
      )),
    ],
    [
      (a: AnimationType) => hasNecessaryKeyframeParts(a),
      constant((props: BaseAnimationWithAssetProps) => (
        <KeyFrameAnimationWithAsset
          actionName={a.actionName!}
          interactionType={interactionType}
          playbackAction={a.playbackAction!}
          {...props}
        />
      )),
    ],
    [stubTrue, constant(Asset3DWithNoAnimation)],
  ])(a);
};
